import React from 'react';

import Table, {Cell, Head} from '@pb/kit-component-table';

import {textAlign} from '../../../tabs-structure.module.styl';

import {CONTRACT_CELL_WIDTH as WIDTH} from './constants';

import {apiV2ContractListHeader} from './contract-list-header.module.styl';

type Props = {
    isPastContract?: boolean,
    creditsDataAvailable: boolean,
};
export const ContractListHeader = (props: Props) => {
    const {isPastContract, creditsDataAvailable} = props;

    const className = textAlign;

    return (
        <div className={apiV2ContractListHeader}>
            <Table>
                <Head>
                    <Cell {...{className, width: WIDTH.contract}}>Contract #</Cell>
                    <Cell {...{className, width: WIDTH.pricing}}>Pricing Model</Cell>
                    {creditsDataAvailable
                        ? <Cell {...{className, width: WIDTH.size}}>Size</Cell>
                        : <Cell {...{className, width: WIDTH.integration}}>Integration Partner</Cell>}
                    <Cell {...{className: 'text-align_center', width: WIDTH.start}}>Start Date</Cell>
                    <Cell {...{className: 'text-align_center', width: WIDTH.end}}>End Date</Cell>
                    {creditsDataAvailable ? (
                        <Cell {...{className: 'text-align_right', width: WIDTH.package}}>Initial Package</Cell>
                    ) : null}
                    {creditsDataAvailable ? (
                        <Cell {...{className: 'text-align_right'}}>
                            {isPastContract ? 'Expired' : 'Remaining'} Credits
                        </Cell>
                    ) : null}
                </Head>
            </Table>
        </div>
    );
};
